






































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { PHDController } from '@/services/request.service'

@Component
export default class FlashCard extends Vue {
  private bookId = 0
  private pages: Array<any> = []
  private audios: Array<any> = []
  private pageNumList: Array<any> = []
  private currentPage = 1
  private currentImage = ''
  private imageLoading = false
  private loadImageProcess = 0
  private audio: any = null
  private audioUrl = ''
  private playing = ''

  private created(): void {
    this.bookId = parseInt(this.$route.params.bookId, 10)
    this.imageLoading = true
    this.getBook()
  }

  private beforeDestroy(): void {
    if (this.audio) {
      this.audio.pause()
    }
  }

  private get devicePixelRatio(): number {
    const agent = navigator.userAgent.toLowerCase()
    if (agent.indexOf('windows') >= 0) {
      return window.devicePixelRatio
    } else {
      return 1
    }
  }

  private getBook(): void {
    PHDController.getPictureBook(this.bookId)
      .then(res => {
        const pages = res.data.pictureBookPageUrl[1803].map(page => page.pageUrl)
        const pageAudios = res.data.pictureBookPageUrl[1803].map(page => {
          return {
            en: page.audioEN,
            zh: page.audioCN,
          }
        })
        let newPages = [...pages]
        let newAudios = [...pageAudios]
        this.loadImages(newPages, () => {
          this.imageLoading = false
        })
        this.pages = newPages
        this.audios = newAudios
        this.currentImage = this.pages[0]
        let list = [] as any
        pages.forEach((page, index) => {
          list.push({
            page: index + 1,
            url: page + '?imageMogr2/auto-orient/thumbnail/310x207>/interlace/1',
          })
        })
        this.pageNumList = list
      })
      .catch(err => {
        console.warn(err)
      })
  }

  private loadImages(sources, callback): void {
    let count = 0
    let images = [] as any
    let imageNum = sources.length
    for (let i in sources) {
      if (sources[i]) {
        images[i] = new Image()
        images[i].onload = () => {
          count++
          this.loadImageProcess = Math.floor((count / imageNum) * 100)
          if (count >= imageNum) {
            callback(images)
          }
        }
        images[i].src = sources[i]
      }
    }
  }

  private flipTo(page): void {
    if (this.audio) {
      this.audio.pause()
    }
    this.currentImage = this.pages[page - 1]
    this.currentPage = page
  }

  private flip(page): void {
    if (page > 0 && page < this.pages.length + 1) {
      if (this.audio) {
        this.audio.pause()
        this.audioUrl = ''
        this.audio = null
        this.playing = ''
      }
      this.currentImage = this.pages[page - 1]
      this.currentPage = page
      if (page === 1) {
        this.$message.warn(this.$tc('phdCourse.firstPage'))
      }
      if (page === this.pages.length) {
        this.$message.warn(this.$tc('phdCourse.lastPage'))
      }
    }
  }

  private playAudio(locale): void {
    this.playing = locale
    const { currentPage, audios } = this
    const url = audios[currentPage - 1][locale]
    if (this.audio) {
      this.audio.pause()
    }
    if (this.audioUrl === url) {
      this.audioUrl = ''
      this.audio = null
      this.playing = ''
    } else {
      this.audioUrl = url
      this.audio = new Audio(url)
      this.audio.play()
      this.audio.addEventListener('ended', () => {
        this.audioUrl = ''
        this.audio = null
        this.playing = ''
      })
    }
  }

  private back(): void {
    this.$router.back()
  }
}
